import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./sectionHeader.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

type SectionHeaderProps = {
  title: string;
  buttonText?: string;
  clickHandler?: () => void;
  isDesktop?: boolean;
  titleClassName?: string;
};

const SectionHeader = ({
  title,
  buttonText,
  clickHandler,
  isDesktop = false,
  titleClassName,
}: SectionHeaderProps) => (
  <div
    className={formatClassNames(styles.titleContainer, isDesktop && styles.desktopTitleContainer)}
  >
    <h2
      className={formatClassNames(isDesktop ? styles.desktopTitle : styles.title, titleClassName)}
    >
      {title}
    </h2>
    {buttonText && clickHandler && (
      <button
        type="button"
        className={isDesktop ? styles.desktopButton : styles.button}
        onClick={clickHandler}
      >
        {buttonText}
      </button>
    )}
  </div>
);

export default wrapperHOC(SectionHeader, {
  componentName: "SectionHeader-SectionRegionElements-SearchPage",
  showForChina: true,
});
